import { CircularProgress } from '@mui/material';
import React from 'react';
import { useStyles } from './LoaderComponent.styles';

const LoaderComponent: React.FC<any> = (props: any) => {
  const {classes} = useStyles({props});
  return (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );
};

export default LoaderComponent;
